
/**
 * 返回level的grandParentId
 * @param level
 * @returns 没有就返回null
 */
function getGrandParentId(level) {
    if (level) {
        let levelArray = level.split(".")
        //必须大于3，才有grandParent
        if (levelArray.length > 3) {
            return levelArray[levelArray.length - 3]
        }
    }
    return null
}

/**
 * 返回level的parentLevel
 * @param level
 * @returns 没有就返回null
 */
function getParentLevel(level) {
    if (level) {
        let levelArray = level.split(".")
        //必须大于2，才有parent
        if (levelArray.length > 2) {
            levelArray.splice(levelArray.length-2,1)
            return levelArray.join(".")
        }
    }
    return null
}

/**
 * 返回level的grandParentLevel
 * @param level
 * @returns 没有就返回null
 */
function getGrandParentLevel(level) {
    if (level) {
        let levelArray = level.split(".")
        //必须大于3，才有grandParent
        if (levelArray.length > 3) {
            levelArray.splice(levelArray.length-3,2)
            return levelArray.join(".")
        }
    }
    return null
}
export default {
    getGrandParentId,
    getParentLevel,
    getGrandParentLevel
};